import { SVGProps } from 'react';

const GitBranchPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 3v12m0 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 0a9 9 0 0 1 9-9m0 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3 9v6m3-3h-6"
    />
  </svg>
);
export default GitBranchPlus;
